export default {
  woMoldColums: [
    { columnName: 'Thứ tự công đoạn', align: 'text-center', visible: true },
    { columnName: 'Mã khuôn', align: 'text-center', visible: true },
    {
      columnName: 'Công đoạn sử dụng khuôn',
      align: 'text-center',
      visible: true,
    },
    { columnName: 'Số serial', align: 'text-center', visible: true },
  ],

  routingDetailColumns: [
    { columnName: '', align: 'text-center', visible: false },
    {
      columnName: 'Mã Công đoạn',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    { columnName: 'Tên công đoạn', align: 'text-center', visible: true },
    { columnName: 'Số lượng đã ghi nhận', align: 'text-center', visible: true },
    {
      columnName: 'Hướng dẫn sản xuất',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'NVL sử dụng',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Khuôn',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },

    {
      columnName: 'Thời gian định mức',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Thời gian canh máy/chuyền',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    // {
    //   columnName: '% Ước tính hoàn thành',
    //   align: 'text-center',
    //   visible: true,
    //   width: 'min-w-[120px]',
    // },
    {
      columnName: 'SL nhân công kế hoạch',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'SL nhân công canh máy/chuyền',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'SL máy móc kế hoạch',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },

    {
      columnName: 'Số SP/ Tờ/ Công đoạn',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Số lượng thực hiện theo từng công đoạn',
      align: 'text-center',
      visible: true,
      width: 'min-w-[200px]',
    },
    {
      columnName: 'Tổng số SP',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Chi phí gia công in offset',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Chi phí bản kẽm',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
  ],
  componentColumns: [
    {
      columnName: 'STT',
      align: 'text-center',
      visible: true,
      width: 'min-w-[60px]',
    },
    {
      columnName: 'Mã NVL',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Tên NVL',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Số lượng',
      align: 'text-center',
      visible: true,
      width: 'min-w-[100px]',
    },
    {
      columnName: 'ĐVT',
      align: 'text-center',
      visible: true,
      width: 'min-w-[60px]',
    },
    {
      columnName: 'Mã Marquette',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Khổ nguyên (mm)',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Khổ in (mm)',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'SL NVL xuất kho',
      align: 'text-center',
      visible: false,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'SL tờ in (tờ cắt) (được xả từ tờ nguyên)',
      align: 'text-center',
      visible: true,
      width: 'min-w-[200px]',
    },
    {
      columnName: 'SL tờ in (tờ cắt) cần đạt tối thiểu',
      align: 'text-center',
      visible: true,
      width: 'min-w-[200px]',
    },
    {
      columnName: 'Thông số màu',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Mã màu pha',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Quy cách in',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Khổ kẽm',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Số kẽm',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Ghi chú',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
    {
      columnName: 'Gia công ngoài',
      align: 'text-center',
      visible: true,
      width: 'min-w-[120px]',
    },
  ],
};
